var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox d-flex justify-center align-center",staticStyle:{"cursor":"pointer"},on:{"click":_vm.updateCheck}},[_c('v-icon',{attrs:{"color":_vm.color,"size":_vm.size}},[_vm._v(" mdi-"+_vm._s(_vm.icon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }